<footer class="footer-container">
  <p class="text">
    {{ "footer.poweredBy" | translate }}
    <a href="https://code-mint.com/" target="_blank" class="company">
      &commat;{{ "footer.companyName" | translate }}
    </a>
  </p>
</footer>
